import Config from '../config';
export default {
  SUCCESS: { name: 'success', category: 'affirmation' },
  // this sound will be pulled from activity's generic soundList, if we'll have one
  // this harcoded sound is used only for demo purposes
  BOINK: {
    name: 'boink',
    category: 'effects',
    src: {
      src: `${Config.digitalAssetsUrl}/activities/wrong.mp3`,
      captions: '',
    },
  },
  AFFIRMATION: {
    name: 'affirmation',
    category: 'affirmation',
    src: {
      src: `${Config.digitalAssetsUrl}/letter-books/2022/affirmations/en-us/awesome-job.mp3`,
      captions: '',
    },
  },
};
